import { IsDefined, Length } from '@lgce/class-validator';
import { BusinessPasswordCheck, ConfirmPassword } from '@shared/common/decorators';

export class AccountActivationDTO {
    @IsDefined()
    @BusinessPasswordCheck()
    @Length(8)
    password!: string;

    @IsDefined()
    @ConfirmPassword('password')
    confirmPassword!: string;
}
